function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
    // const header_overlay = document.getElementById("mega-menu-overlay");
    //  header_overlay.style.display = 'none';
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

function convertCountryCodeToName(countryCode) {
  const regionNames = new Intl.DisplayNames(["en"], { type: "region" });
  return regionNames.of(countryCode);
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    if (
      !this.mainDetailsToggle.classList.contains("mobile-facets__disclosure")
    ) {
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
    }
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('[id^="ModalClose-"]').forEach((el) => {
      el.addEventListener("click", this.hide.bind(this, false));
    });
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    const id = this.id;
    const event = new CustomEvent("modalClosed", {
      detail: { id },
      bubbles: false,
    });
    this.dispatchEvent(event);
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    if (poster.classList.contains("no_poster")) {
      this.checkIfVideoInView = this.checkIfVideoInView.bind(this);
      document.addEventListener("scroll", this.checkIfVideoInView);
    } else {
      poster.addEventListener("click", this.loadContent.bind(this));
    }
  }

  checkIfVideoInView() {
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    const posterBoundingClientRect = poster.getBoundingClientRect();
    const top = posterBoundingClientRect.top - 50;
    const bottom = posterBoundingClientRect.bottom + 50;
    const posterInView = top <= window.innerHeight && bottom >= 0;
    if (posterInView) {
      this.loadContent();
      this.removeVideoListener();
    }
  }

  removeVideoListener(el) {
    document.removeEventListener("scroll", this.checkIfVideoInView);
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      ).focus();

      const ad = this.closest(".card-wrapper__ad");
      if (!ad) return;
      ad.classList.add("video-loaded");
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class ProductMedia extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      mediaSlider: this.querySelector(".product__media-slider"),
      imageContainer: this.querySelectorAll(".product-image-container"),
      videoContainer: this.querySelector(".product-video-container"),
      variantBadge: this.querySelectorAll(".product__variant-badge"),
    };
    this.$mediaSlider = null;
    this.hasVideo = this.querySelector(".product-video-container")
      ? true
      : false;
    this.lightbox = null;
  }

  connectedCallback() {
    this.elements.videoContainer?.addEventListener(
      "click",
      this.toggleVideoPlay.bind(this)
    );

    this.initLightbox();
  }

  /**
   * Init the product media slider
   * @param {String} color - Hyphenated color option
   */
  initMediaSlider(color) {
    if (this.$mediaSlider !== null) return;
    if (this.elements.imageContainer.length <= 1) return;
    this.$mediaSlider = $(this.elements.mediaSlider).slick({
      slidesToShow: 1.05,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      speed: 0,
      infinite: false,
    });

    // Filter out color
    if (color) {
      this.$mediaSlider.slick(
        "slickFilter",
        `[option="${color}"], .product-video-container`
      );
    }

    if (this.hasVideo) {
      this.updateSliderDots();
    }
  }

  /**
   * Update the slider with the current color
   *
   * @param {String} color - Hyphenated color option
   * @returns
   */
  updateMediaSlider(color) {
    if (this.$mediaSlider === null) return;

    this.$mediaSlider
      .slick("slickUnfilter")
      .slick("slickFilter", `[option="${color}"], .product-video-container`)
      .slick("slickGoTo", 0);

    if (this.hasVideo) {
      this.updateSliderDots();
    }
  }

  destroyMediaSlider() {
    if (this.$mediaSlider === null) return;
    this.$mediaSlider.slick("slickUnfilter");
    this.$mediaSlider.slick("unslick");
    this.$mediaSlider = null;
  }

  updateSliderDots() {
    const slickDots =
      this.elements.mediaSlider.querySelectorAll(".slick-dots li");
    const lastDot = slickDots[slickDots.length - 1];
    lastDot.classList.add("video-dot");
  }

  initLightbox() {
    this.lightbox = GLightbox();
  }

  toggleVideoPlay(event) {
    const el = event.currentTarget;
    const video = el.querySelector("video");
    const iconPlay = el.querySelector(".icon-play");
    const iconStop = el.querySelector(".icon-stop");

    if (video.paused) {
      video.play();
      iconPlay.style.display = "none";
      iconStop.style.display = "block";
    } else {
      video.pause();
      iconPlay.style.display = "block";
      iconStop.style.display = "none";
    }
  }

  updateVariantBadge(currentVariant) {
    if (!currentVariant) return;
    this.elements.variantBadge.forEach((el) => {
      if (parseInt(el.dataset.variantId) === currentVariant.id) {
        el.classList.remove("d-none");
      } else {
        el.classList.add("d-none");
      }
    });
  }
}

customElements.define("product-media", ProductMedia);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.updateOptions();
    this.updateSoldOut();
    this.disabledOtherVariant();
    this.addEventListener("change", this.onVariantChange);
    this.$mediaSlider = null;
    this.elements = {
      productMedia: this.closest(".product").querySelector("product-media"),
      toggleLongSizesButton: this.querySelector("[data-js-toggle-long-sizes]"),
      colorLabels: this.querySelectorAll(".product-form__input-color label"),
      colorInputs: this.querySelectorAll(".product-form__input-color input"),
      colorsInLongJSON: this.querySelector(".colors-in-long-json"),
    };
    this.mediaQuery = window.matchMedia("(max-width: 990px)");
    this.isMobile = this.mediaQuery.matches;
  }

  assignVariantIds() {
    const currentOptions = this.options; // Currently selected values [color, size]
    const variants = this.getVariantData();
    const product = variants[0].product;

    // Do not run on gift cards
    if (product.handle == "gift-card") {
      return;
    }

    // Process both color and size options
    this.querySelectorAll('input[name="1"], input[name="2"]').forEach(
      (input) => {
        // Get the associated label (using 'for' attribute or parent wrapper)
        const label =
          input.closest("label") ||
          document.querySelector(`label[for="${input.id}"]`);

        if (!label) return; // Skip if no label found

        // Test if this option combination exists
        const testOptions = [...currentOptions];
        testOptions[parseInt(input.name) - 1] = input.value;

        // Find matching variant
        const variant = variants.find(
          (v) => v.option1 === testOptions[0] && v.option2 === testOptions[1]
        );

        // Update label instead of input
        if (variant) {
          label.setAttribute("data-hemlo", variant.id);
          label.classList.remove("hidden");
        } else {
          label.removeAttribute("data-hemlo"); // Clean up if no match
          label.classList.add("hidden");
        }
      }
    );
  }

  markAllUnavailableOptions() {
    const variants = this.getVariantData();

    // Group availability by option
    const availableColors = new Set();
    const availableSizes = new Set();

    variants.forEach((variant) => {
      if (variant.available) {
        availableColors.add(variant.option1);
        availableSizes.add(variant.option2);
      }
    });

    // Disable color inputs that have no available variants
    this.querySelectorAll('input[name="1"]').forEach((input) => {
      if (!availableColors.has(input.value)) {
        input.classList.add("disabled");
        //  input.disabled = true;
        console.log(`❌ Color "${input.value}" is out of stock`);
      }
    });

    // Disable size inputs that have no available variants
    this.querySelectorAll('input[name="2"]').forEach((input) => {
      if (!availableSizes.has(input.value)) {
        input.classList.add("disabled");
        input.disabled = true;
        console.log(`❌ Size "${input.value}" is out of stock`);
      }
    });
  }
  // autoSelectValidVariant() {
  //   const variants = this.getVariantData();
  //   const selectedColor = this.querySelector('input[name="1"]:checked')?.value;
  //   const selectedSize = this.querySelector('input[name="2"]:checked')?.value;

  //   // 1. Check if the selected combo is valid and available
  //   let validVariant = variants.find(
  //     (v) => v.option1 === selectedColor && v.option2 === selectedSize && v.available
  //   );

  //   // 2. If not valid, find the first available variant for the selected color
  //   if (!validVariant && selectedColor) {
  //     validVariant = variants.find(
  //       (v) => v.option1 === selectedColor && v.available
  //     );
  //   }

  //   // 3. If still not found, fallback to first available variant
  //   if (!validVariant) {
  //     validVariant = variants.find((v) => v.available);
  //   }

  //   // 4. Auto-select inputs using safe selectors
  //   if (validVariant) {
  //     const safeColor = CSS.escape(validVariant.option1);
  //     const safeSize = CSS.escape(validVariant.option2);

  //     const colorInput = this.querySelector(`input[name="1"][value="${safeColor}"]`);
  //     const sizeInput = this.querySelector(`input[name="2"][value="${safeSize}"]`);

  //     //if (colorInput && !colorInput.checked) colorInput.checked = true;
  //    // if (sizeInput && !sizeInput.checked) sizeInput.checked = true;

  //     console.log(`✅ Auto-selected valid variant: ${validVariant.option1} / ${validVariant.option2}`);
  //   } else {
  //     console.warn("❌ No valid variant found.");
  //   }

  // }

  autoSelectValidVariant() {
    const variants = this.getVariantData();
    const selectedColor = this.querySelector('input[name="1"]:checked')?.value;
    const selectedSize = this.querySelector('input[name="2"]:checked')?.value;

    console.log("Current selection:", { selectedColor, selectedSize });

    // 1. Check if the selected combo exists (regardless of availability)
    let validVariant = variants.find(
      (v) => v.option1 === selectedColor && v.option2 === selectedSize
    );

    // 2. If not found, find any variant for the selected color (regardless of availability)
    if (!validVariant && selectedColor) {
      validVariant = variants.find((v) => v.option1 === selectedColor);
      console.log("Found alternative variant for color:", validVariant);
    }

    // 3. If still not found, fallback to first variant (regardless of availability)
    if (!validVariant) {
      validVariant = variants[0];
      console.log("Falling back to first variant:", validVariant);
    }

    // 4. Auto-select inputs
    if (validVariant) {
      const safeColor = CSS.escape(validVariant.option1);
      const safeSize = CSS.escape(validVariant.option2);

      console.log("Attempting to select:", {
        color: safeColor,
        size: safeSize,
      });

      const colorInput = this.querySelector(
        `input[name="1"][value="${safeColor}"]`
      );
      const sizeInput = this.querySelector(
        `input[name="2"][value="${safeSize}"]`
      );

      console.log("Found inputs:", { colorInput, sizeInput });

      let selectionChanged = false;

      if (colorInput && !colorInput.checked) {
        console.log("Updating color selection to:", safeColor);
        colorInput.checked = true;
        colorInput.dispatchEvent(new Event("change", { bubbles: true }));
        selectionChanged = true;
      }

      if (sizeInput && !sizeInput.checked) {
        console.log("Updating size selection to:", safeSize);
        sizeInput.checked = true;
        sizeInput.dispatchEvent(new Event("change", { bubbles: true }));
        selectionChanged = true;
      }

      if (selectionChanged) {
        console.log(
          `✅ Selected variant: ${validVariant.option1} / ${validVariant.option2} (Available: ${validVariant.available})`
        );
      } else {
        console.log("No selection change needed");
      }
    } else {
      console.warn("❌ No variants found.");
    }
  }

  connectedCallback() {
    this.updateMasterId();
    this.markAllUnavailableOptions();
    this.updateSoldOut(); // ✅ Immediately mark out-of-stock options
    this.assignVariantIds();

    if (this.isMobile) {
      this.elements.productMedia.initMediaSlider(this.currentColor);
    }

    // Listen for device resizing
    this.mediaQuery.addEventListener(
      "change",
      this.onBreakpointChange.bind(this)
    );

    // Bind UI listeners
    this.elements.toggleLongSizesButton?.addEventListener(
      "click",
      this.handleLongSizesVisibility.bind(this)
    );

    // On page load
    if (this.currentVariant) {
      this.hideNotifyBtn();
    }
    this.querySelectorAll('input[name="1"]').forEach((input) => {
      input.addEventListener("change", () => {
        this.autoSelectValidVariant();
        this.onVariantChange();
      });
    });
  }

  onBreakpointChange(e) {
    // Destroy slider on desktop
    if (!e.matches && this.elements.productMedia.$mediaSlider !== null) {
      this.elements.productMedia.destroyMediaSlider();
      this.updateImagesVisibility();
    } else if (e.matches && this.elements.productMedia.$mediaSlider === null) {
      this.elements.productMedia.initMediaSlider(this.currentColor);
    }
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateMedia();
    this.disabledOtherVariant();
    this.updateSoldOut();
    this.updateFieldsetText();
    this.assignVariantIds();
    // this.selectFirstSize(event.target);

    if (!this.currentVariant) {
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateBundles();
      this.updateInventoryTracker();
      this.hideNotifyBtn();
    }
  }

  disabledOtherVariant() {
    const inputs = this.querySelectorAll("input");
    const optionElements = Array.from(this.querySelectorAll("fieldset"));

    if (!this.currentVariant) return;
    if (this.currentVariant.product.handle == "gift-card") return;

    const isSoldOut = !this.currentVariant.available;
    console.log("isSoldOut", isSoldOut);
    const voa = document.querySelector(".variant-option-availability");
    if (isSoldOut) {
      voa.style.display = "flex";
    } else {
      voa.style.display = "none";
    }

    // Select the first .product-form__input inside .variant-radios
    const firstOptionGroup = this.querySelector(
      "variant-radios > .product-form__input:first-child"
    );

    if (firstOptionGroup) {
      const allInputs = firstOptionGroup.querySelectorAll("input");

      allInputs.forEach((input) => {
        if (isSoldOut && input.checked) {
          input.classList.add("disabled");
        } else {
          input.classList.remove("disabled");
        }
      });
    }
  }

  updateInventoryTracker() {
    const section = this.closest("section");
    const inventoryAlert = section.querySelectorAll(
      "[data-js-variant-inventory]"
    );

    if (!inventoryAlert) {
      return;
    }

    inventoryAlert.forEach((el) => {
      const id = parseInt(el.dataset.variantId);
      const lowInventory = /true/.test(el.dataset.lowInventory);
      const available = /true/.test(el.dataset.available);

      if (id === this.currentVariant.id && lowInventory && available) {
        el.style.display = "flex";
      } else {
        el.style.display = "none";
      }
    });
  }

  updateBundles() {
    document.querySelectorAll(".main-upsell").forEach((bundle) => {
      if (parseInt(bundle.dataset.vid) == this.currentVariant.id)
        bundle.style.display = "block";
      else bundle.style.display = "none";
    });
  }

  updateOptions() {
    const fieldsets = this.querySelectorAll("fieldset");
    this.options = Array.from(fieldsets).map((fieldset) => {
      const checked = fieldset.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : "";
    });
    console.log("🔄 Updated selected options:", this.options);
  }

  updateMasterId() {
    const variants = this.getVariantData();
    this.currentVariant =
      variants.find((variant) => {
        return !variant.options.some((opt, i) => opt !== this.options[i]);
      }) || null;
    console.log("✅ currentVariant:", this.currentVariant);
  }

  updateMedia() {
    this.updateImagesVisibility();
    this.elements.productMedia.updateMediaSlider(this.currentColor);
    this.elements.productMedia.updateVariantBadge(this.currentVariant);
  }

  updateImagesVisibility() {
    if (this.currentColor) {
      const images = this.elements.productMedia.querySelectorAll(
        ".product-image-container img"
      );

      images.forEach((image) => {
        const imageAlt = handleize(image.alt);
        if (imageAlt === this.currentColor) {
          image.parentElement.style.display = "block";
        } else {
          image.parentElement.style.display = "none";
        }
      });
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateSoldOut() {
    const optionElements = Array.from(this.querySelectorAll("fieldset"));
    if (!optionElements) return;

    this.optionValues = optionElements.map((el) => {
      return el.tagName === "SELECT"
        ? el.value
        : Array.from(el.querySelectorAll("input")).find(
            (radio) => radio.checked
          ).value;
    });

    const selectedColor = this.options[0]; // Assuming color is the first option
    const selectedSize = this.options[1]; // Assuming size is the second option

    // Reset all inputs - remove disabled and soldout classes
    optionElements.forEach((fieldset) => {
      const inputs = fieldset.querySelectorAll("input");
      inputs.forEach((input) => {
        input.classList.remove("disabled", "soldout");
      });
    });

    // Handle COLOR filtering based on selected SIZE
    if (selectedSize && optionElements[0]) {
      const colorFieldset = optionElements[0];
      const colorInputs = colorFieldset.querySelectorAll("input");

      colorInputs.forEach((colorInput) => {
        const colorValue = colorInput.value;

        // Check if this color has the selected size available
        const variantWithColorAndSize = this.getVariantData().find(
          (variant) =>
            variant.option1 === colorValue &&
            variant.option2 === selectedSize &&
            variant.available
        );

        if (!variantWithColorAndSize) {
          colorInput.classList.add("disabled", "soldout");
          console.log(
            `❌ Color ${colorValue} doesn't have size ${selectedSize} available`
          );
        }
      });
    }

    // Handle SIZE filtering based on selected COLOR
    if (selectedColor && optionElements[1]) {
      const sizeFieldset = optionElements[1];
      const sizeInputs = sizeFieldset.querySelectorAll("input");

      sizeInputs.forEach((sizeInput) => {
        const sizeValue = sizeInput.value;

        // Find the variant for this color and size combination
        const variantWithColorAndSize = this.getVariantData().find(
          (variant) =>
            variant.option1 === selectedColor && variant.option2 === sizeValue
        );

        if (!variantWithColorAndSize || !variantWithColorAndSize.available) {
          // Use 'disabled' for both non-existent and sold-out variants
          sizeInput.classList.add("disabled", "soldout");
          if (!variantWithColorAndSize) {
            console.log(
              `❌ Size ${sizeValue} doesn't exist in color ${selectedColor}`
            );
          } else {
            console.log(
              `❌ Size ${sizeValue} is sold out in color ${selectedColor}`
            );
          }
        } else {
          console.log(
            `✅ Size ${sizeValue} is available in color ${selectedColor}`
          );
        }
      });
    }
  }

  updateFieldsetText() {
    const currOptions = this.options;
    const fieldsets = this.querySelectorAll("fieldset");
    fieldsets.forEach((fieldset, index) => {
      const optionValue = fieldset.querySelector(
        "legend [data-selected-option]"
      );
      optionValue.innerText = currOptions[index];
    });
    document
      .querySelectorAll(".product-options-mobile .product-option-value")
      .forEach((val, index) => {
        val.innerText = currOptions[index];
      });
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }
  // old function for price
  // renderProductInfo() {
  //   fetch(
  //     `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
  //       this.dataset.originalSection
  //         ? this.dataset.originalSection
  //         : this.dataset.section
  //     }`
  //   )
  //     .then((response) => response.text())
  //     .then((responseText) => {
  //       let html = new DOMParser().parseFromString(responseText, "text/html");
  //       let destination = document.getElementById(
  //         `price-${this.dataset.section}`
  //       );
  //       let source = html.getElementById(
  //         `price-${
  //           this.dataset.originalSection
  //             ? this.dataset.originalSection
  //             : this.dataset.section
  //         }`
  //       );
  //       if (source && destination) destination.innerHTML = source.innerHTML;

  //       let price = document.getElementById(`price-${this.dataset.section}`);

  //       if (price) price.classList.remove("visibility-hidden");

  //       this.toggleAddButton(
  //         !this.currentVariant.available,
  //         window.variantStrings.soldOut
  //       );
  //     });
  // }

  renderProductInfo() {
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!price || !this.currentVariant) return;

    const priceValue = (this.currentVariant.price / 100).toFixed(2);
    const compareAtPrice = this.currentVariant.compare_at_price
      ? (this.currentVariant.compare_at_price / 100).toFixed(2)
      : null;
    var isOnSale = "";
    var isOnSale =
      compareAtPrice && Number(compareAtPrice) > Number(priceValue);
    console.log("compareAtPrice", compareAtPrice);
    console.log("priceValue", priceValue);
    console.log("isOnSale", isOnSale);
    let html = `
    <div class="price price--show-badge${isOnSale ? " price--on-sale" : ""}">
      <div class="price__container">
  `;

    if (isOnSale) {
      html += `
      <div class="price__regular">
        <span class="visually-hidden visually-hidden--inline">Regular price</span>
        <span class="price-item price-item--regular">€${compareAtPrice}</span>
      </div>
      <div class="price__sale">
        <span class="visually-hidden visually-hidden--inline">Regular price</span>
        <span>
          <s class="price-item price-item--regular">€${compareAtPrice}</s>
        </span>
        <span class="visually-hidden visually-hidden--inline">Sale price</span>
        <span class="price-item price-item--sale price-item--last">€${priceValue}</span>
      </div>
    `;
    } else {
      html += `
      <div class="price__regular">
        <span class="visually-hidden visually-hidden--inline">Regular price</span>
        <span class="price-item price-item--regular">€${priceValue}</span>
      </div>
    `;
    }

    html += `
        <small class="unit-price caption hidden">
          <span class="visually-hidden">Unit price</span>
          <span class="price-item price-item--last">
            <span></span>
            <span aria-hidden="true">/</span>
            <span class="visually-hidden">&nbsp;per&nbsp;</span>
            <span></span>
          </span>
        </small>
      </div>
  `;

    if (isOnSale) {
      html += `
      <span class="badge price__badge-sale color-accent-2">Sale</span>
    `;
    }

    html += `</div>`;

    price.innerHTML = html;
    price.classList.remove("visibility-hidden");

    this.toggleAddButton(
      !this.currentVariant.available,
      window.variantStrings.soldOut
    );
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    this.toggleAddButton(true, "", true);
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  selectFirstSize(el) {
    if (!el.parentNode.classList.contains("product-form__input-color")) {
      return;
    }
    const sizeFieldSet = this.querySelector(".product-form__input-size");
    const firstSizeInput = sizeFieldSet.querySelector("input");
    firstSizeInput.click();
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector("[data-custom-product-json]").textContent);
    return this.variantData;
  }

  handleLongSizesVisibility() {
    const { colors } = JSON.parse(
      this.querySelector("[data-colors-in-long-json]").textContent
    );
    this.elements.toggleLongSizesButton.classList.toggle("is-filtered");

    if (this.elements.toggleLongSizesButton.classList.contains("is-filtered")) {
      this.toggleLongColorInputsVisibility(colors, true);
    } else {
      this.toggleLongColorInputsVisibility(colors, false);
    }
  }

  toggleLongColorInputsVisibility(colors, isFiltered) {
    this.elements.colorInputs.forEach((el) => {
      const id = el.id;
      const value = el.value;
      const isLongColor = colors.find((c) => c === value);
      const siblingLabel = this.querySelector(`label[for="${id}"]`);

      if (isFiltered) {
        if (isLongColor) {
          siblingLabel.classList.add("hasLong");
        } else {
          siblingLabel.setAttribute("disabled", true);
          siblingLabel.style.opacity = "0.2";
        }
      } else {
        if (isLongColor) {
          siblingLabel.classList.remove("hasLong");
        } else {
          siblingLabel.removeAttribute("disabled");
          siblingLabel.style.opacity = "1";
        }
      }
    });
  }

  hideNotifyBtn() {
    const { currentVariant } = this;
    const parentNode = this.closest(".product");
    const notifyBtn = parentNode.querySelector(".klaviyo-bis-trigger");

    // Do nothing if the button does not exist
    if (!notifyBtn) return;

    // Remove hidden class on all variant changes first
    parentNode.classList.remove("hide-bis-btn");

    if (currentVariant.metafields.length > 0) {
      const foundMetafield = currentVariant.metafields.find((m) =>
        m.hasOwnProperty("hide_notify_button")
      );

      if (foundMetafield && foundMetafield["hide_notify_button"]) {
        parentNode.classList.add("hide-bis-btn");
      }
    }
  }

  get selectedOptionValues() {
    return Array.from(
      this.querySelectorAll("select option[selected], fieldset input:checked")
    ).map(({ value }) => value);
  }

  get currentColor() {
    if (!this.currentVariant) return null;

    const colorIndex = this.currentVariant.product.options.findIndex(
      (option) => {
        return option.toLowerCase() === "color";
      }
    );

    if (colorIndex === -1) return null;

    return this.selectedOptionValues.length
      ? handleize(this.selectedOptionValues[colorIndex])
      : null;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const optionGroups = Array.from(this.querySelectorAll("fieldset"));
    this.options = optionGroups.map((group) => {
      const checked = group.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : "";
    });
    console.log("🔄 Updated selected options:", this.options);
  }
}

customElements.define("variant-radios", VariantRadios);

class TooltipOpener extends HTMLElement {
  constructor() {
    super();

    const tooltip = new bootstrap.Tooltip(this);
  }
}

customElements.define("tooltip-component", TooltipOpener);

// WICK SPECIFIC FUNCTIONALITY

function serializeJSON(form) {
  const formData = new FormData(form);
  const pairs = {};
  const consistent = {};
  for (const [name, value] of formData) {
    if (value === null || value === "" || JSON.stringify(value) === "{}") {
      continue;
    } else if (name == "form_type" || name == "utf8") {
      consistent[name] = value;
    } else {
      pairs[name] = value;
    }
  }
  return JSON.stringify({ consistent, data: pairs }, null, 2);
}

class FormBuilder extends HTMLElement {
  constructor() {
    super();
    this.form = document.querySelector("#warranty-form");
    this.thanks = document.querySelector("#thanks");
    this.form_submit = document.getElementById("custom-form-submit");

    if (!this.form) return;

    this.form.addEventListener("submit", this.formSubmit.bind(this));
    this.querySelectorAll(".field__input-file").forEach((input) =>
      input.addEventListener("change", this.onFileInput.bind(this))
    );
  }

  onFileInput(event) {
    const input = event.target;
    const file_link = input.nextElementSibling;
    if (input.files) {
      this.form_submit.classList.add("button--loading");
      this.form_submit.disabled = true;

      const file = input.files[0];
      const formData = new FormData();
      formData.append("file", file);
      formData.append("document", this.form_submit.dataset.source);

      var res = Array.from(formData.entries(), ([key, prop]) => ({
        [key]: {
          ContentLength: typeof prop === "string" ? prop.length : prop.size,
        },
      }));

      if (file.size > 5000000) {
        alert("File size too large, please reduce file size and resubmit");
        input.value = "";
      } else {
        fetch("https://hook.us1.make.com/2uytqypv4tgk945njxndndq348ujhkc3", {
          method: "POST",
          body: formData,
        })
          .then((response) => response.text())
          .then((data) => {
            file_link.value = data;
            this.form_submit.classList.remove("button--loading");
            document.getElementById("custom-form-submit").disabled = false;
          })
          .catch((error) => {
            this.form_submit.classList.remove("button--loading");
            document.getElementById("custom-form-submit").disabled = false;
          });
      }
    }
  }

  formSubmit(event) {
    event.preventDefault();
    this.form_submit.classList.add("animate");
    let redirect_url;
    if (this.hasAttribute("data-redirect")) {
      redirect_url = this.dataset.redirect;
    }
    fetch(this.dataset.send, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: serializeJSON(this.form),
    })
      .then((response) => response.json())
      .then((data) => {
        var form_error = document.getElementById("form_error");
        if (!form_error) {
          form_error = document.createElement("div");
          form_error.id = "form_error";
          this.form_submit.parentNode.insertBefore(
            form_error,
            this.form_submit.nextSibling
          );
        }
        this.form_submit.classList.remove("animate");
        this.form_submit.classList.add("success");
        setTimeout(
          function () {
            this.form.classList.add("hidden");
            this.thanks.classList.remove("hidden");
            this.thanks.scrollIntoView();
            if (data.success) {
              if (redirect_url) {
                setTimeout(function () {
                  window.location.href = redirect_url;
                }, 500);
              }
            } else {
              form_error.innerText = data.reason;
            }
          }.bind(this),
          500
        );
      })
      .catch((error) => {
        console.error("Error:", error);
        this.form_submit.classList.remove("animate");
        this.form_submit.classList.add("error");
      });
  }
}

customElements.define("form-builder", FormBuilder);

String.prototype.imgURL = function (size) {
  return this.replace(/\.jpg|\.png|\.gif|\.jpeg/g, function (match) {
    return "_" + size + match;
  });
};
class StoreLocatorForm extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      form: this.querySelector("form"),
      input: this.querySelector("[data-postal-code-input]"),
    };
  }

  connectedCallback() {
    this.elements.form.addEventListener("submit", this.onFormSubmit.bind(this));
  }

  onFormSubmit(evt) {
    evt.preventDefault();
    const form = evt.currentTarget;
    const actionUrl = form.getAttribute("action");
    const postalCode = this.elements.input.value;

    if (postalCode === "") {
      return;
    }

    window.location = `${actionUrl}?postal-code=${postalCode}`;
  }
}

customElements.define("store-locator-form", StoreLocatorForm);

// Lazy load background images
const lazyBackgrounds = document.querySelectorAll("[data-lazy-load-bg]");
const lazyVideos = document.querySelectorAll("video.lazyload");

function initLazyLoadBackgrounds() {
  let lazyBackgroundObserver = new IntersectionObserver(function (
    entries,
    observer
  ) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add("lazy-loaded");
        lazyBackgroundObserver.unobserve(entry.target);
      }
    });
  });

  lazyBackgrounds.forEach(function (lazyBackground) {
    lazyBackgroundObserver.observe(lazyBackground);
  });
}

function initLazyVideos() {
  const lazyVideoObserver = new IntersectionObserver(function (
    entries,
    observer
  ) {
    entries.forEach(function (video) {
      if (video.isIntersecting) {
        for (var source in video.target.children) {
          var videoSource = video.target.children[source];
          if (
            typeof videoSource.tagName === "string" &&
            videoSource.tagName === "SOURCE"
          ) {
            videoSource.src = videoSource.dataset.src;
          }
        }

        video.target.load();
        video.target.classList.remove("lazyload");
        lazyVideoObserver.unobserve(video.target);
      }
    });
  });

  lazyVideos.forEach(function (lazyVideo) {
    lazyVideoObserver.observe(lazyVideo);
  });
}

initLazyLoadBackgrounds();
initLazyVideos();

class ProductCard extends HTMLElement {
  constructor() {
    super();

    this.variantSlider = this.querySelectorAll(".product-card__variant-nav");
    this.primaryImg = this.querySelector(".product-card__featured-image");
    this.secondaryImg = this.querySelector(".product-card__secondary-image");
    this.primaryLink = this.querySelector(".product-card__featured-image-link");
    this.secondaryLink = this.querySelector(
      ".product-card__secondary-image-link"
    );
  }

  connectedCallback() {
    this.variantSlider.forEach((el) => {
      el.addEventListener("mouseenter", this.onSwatchEnter.bind(this));
    });

    this.initVariantSlider();
  }

  onSwatchEnter(event) {
    const el = event.currentTarget;
    const variantUrl = el.getAttribute("variant_url");
    const primaryImageSrc = el.getAttribute("primary-image-src");
    const primaryImageSrcset = el.getAttribute("primary-image-srcset");
    const secondaryImageSrc = el.getAttribute("secondary-image-src");
    const secondaryImageSrcset = el.getAttribute("secondary-image-srcset");

    this.primaryLink.setAttribute("href", variantUrl);
    this.primaryImg.setAttribute("src", primaryImageSrc);
    this.primaryImg.setAttribute("srcset", primaryImageSrcset);

    if (this.secondaryImg && this.secondaryLink) {
      this.secondaryLink.setAttribute("href", variantUrl);
      this.secondaryImg.setAttribute("src", secondaryImageSrc);
      this.secondaryImg.setAttribute("srcset", secondaryImageSrcset);
    }
  }

  initVariantSlider() {
    const slider = $(
      this.querySelector(
        ".product-card__variants-slider:not(.slick-initialized)"
      )
    ).slick();
  }
}

customElements.define("product-card", ProductCard);

function smoothScroll(to, duration) {
  const element = document.scrollingElement || document.documentElement;
  const start = element.scrollTop;
  const change = to - start;
  const increment = 20;
  let currentTime = 0;

  const animateScroll = function () {
    currentTime += increment;
    const val = Math.easeInOutQuad(currentTime, start, change, duration);
    element.scrollTop = val;
    if (currentTime < duration) {
      setTimeout(animateScroll, increment);
    }
  };
  animateScroll();
}

/* eslint-disable */
// t = current time
// b = start value
// c = change in value
// d = duration
Math.easeInOutQuad = function (t, b, c, d) {
  t /= d / 2;
  if (t < 1) return (c / 2) * t * t + b;
  t--;
  return (-c / 2) * (t * (t - 2) - 1) + b;
};
/* eslint-enable */

/**
 * Convert a string into a handle like Shopify's
 *
 * @param {String} str - String to handleize
 * @returns - handleized string
 */
function handleize(str) {
  str = str.toLowerCase();
  str = str.replace(/[^a-z0-9\s-]/g, ""); // Remove special characters
  str = str.replace(/\s+/g, "-"); // Replace spaces with hyphens
  return str;
}

class ProductUpsell extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      main: this.querySelector("[data-js-upsell-main]"),
      openBtn: this.querySelector("[data-js-upsell-popup-open]"),
      select: this.querySelector("[data-js-upsell-select]"),
      price: this.querySelector("[data-js-upsell-price]"),
      image: this.querySelector("[data-js-upsell-image]"),
      anchorTag: this.querySelector("[data-js-variant-url]"),
    };
  }

  connectedCallback() {
    document.body.addEventListener("click", this.closeUpsellPopup.bind(this));

    this.elements.openBtn.addEventListener(
      "click",
      this.openUpsellPopup.bind(this)
    );

    this.elements.select.addEventListener(
      "change",
      this.onSelectChange.bind(this)
    );
  }

  openUpsellPopup() {
    this.elements.main.classList.add("upsell_popup_visible");
  }

  closeUpsellPopup(event) {
    if (
      event.target != this.elements.openBtn &&
      !event.target.closest(".upsell_popup-main") &&
      this.elements.main.classList.contains("upsell_popup_visible")
    ) {
      this.elements.main.classList.remove("upsell_popup_visible");
    }
  }

  onSelectChange(event) {
    const el = event.target;
    const selectedIndex = el.selectedIndex;
    const selectedOption = el.options[selectedIndex];

    this.updateUpsellPrice(selectedOption);
    this.updateUpsellImage(selectedOption);
    this.updateUpsellUrl(selectedOption);
  }

  updateUpsellPrice(el) {
    this.elements.price.innerHTML = el.dataset.variantPrice;
  }

  updateUpsellImage(el) {
    this.elements.image.src = el.dataset.variantImage;
  }

  updateUpsellUrl(el) {
    this.elements.anchorTag.href = el.dataset.variantUrl;
  }
}

customElements.define("product-upsell", ProductUpsell);

class SizeGuide extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      table: this.querySelector("table"),
      checkbox: this.querySelector(".size_guide_switch__input"),
      cellsIN: this.querySelectorAll('span[data-unit="in"]'),
      cellsCM: this.querySelectorAll('span[data-unit="cm"]'),
      sizeGuideBtn: document.querySelectorAll('a[href="#size_guide"]'),
      overlay: document.getElementById("size_guide_overlay"),
      popUp: document.querySelector(".size-guide-main"),
      popupCloseBtn: document.querySelector(".size-guide__close-btn"),
    };
  }

  connectedCallback() {
    this.elements.checkbox.addEventListener(
      "change",
      this.onCheckboxChange.bind(this)
    );

    this.elements.sizeGuideBtn.forEach((el) => {
      el.addEventListener("click", this.showSizeGuide.bind(this));
    });

    this.elements.overlay.addEventListener(
      "click",
      this.hideSizeGuide.bind(this)
    );
    this.elements.popupCloseBtn.addEventListener(
      "click",
      this.hideSizeGuide.bind(this)
    );
  }

  onCheckboxChange(event) {
    const el = event.currentTarget;

    if (el.checked) {
      this.elements.table.setAttribute("data-unit", "cm");
      this.hideUnitCell(this.elements.cellsIN, true);
      this.hideUnitCell(this.elements.cellsCM, false);
    } else {
      this.elements.table.setAttribute("data-unit", "in");
      this.hideUnitCell(this.elements.cellsIN, false);
      this.hideUnitCell(this.elements.cellsCM, true);
    }
  }

  hideUnitCell(elements, hide) {
    elements.forEach((el) => {
      if (hide) {
        el.classList.add("d-none");
        el.classList.remove("d-block");
      } else {
        el.classList.remove("d-none");
        el.classList.add("d-block");
      }
    });
  }

  showSizeGuide(event) {
    event.preventDefault();
    this.elements.overlay.classList.add("size_guide_shown");
    this.elements.popUp.classList.add("size_guide_shown");
    document.querySelector("body").style.overflow = "hidden";
  }

  hideSizeGuide() {
    this.elements.overlay.classList.remove("size_guide_shown");
    this.elements.popUp.classList.remove("size_guide_shown");
    document.querySelector("body").style.overflow = "";
  }
}

customElements.define("size-guide", SizeGuide);
